import React from "react";

import { DatasheetSettingsConfigureTableFormat } from "../components/configure-table/configure-table.types";

export type TableValue = {
  formats: Array<DatasheetSettingsConfigureTableFormat>;
  selectedDropdownFormatId?: DatasheetSettingsConfigureTableFormat["id"];
  formatName: string;
};

export type TableControllerProps = {
  onChange: (params: TableValue) => void; 
  value?: TableValue;
};

export const useTableFieldController = (props: TableControllerProps) => {
  const { onChange } = props;

  const tableFormats = [
    { id: 11, name: "Notes", imageURL: "gif/dropdown.gif", order: 1 },
    { id: 22, name: "021323", imageURL: "gif/text.gif", order: 2 },
    { id: 33, name: "Checkbox", imageURL: "gif/checkbox.gif", order: 3 },
  ];

  const formats = React.useMemo(
    () => [
      { id: 1, name: "test 1", imageURL: "gif/dropdown.gif" },
      { id: 2, name: "test 2", imageURL: "gif/text.gif" },
      { id: 3, name: "test 3", imageURL: "gif/checkbox.gif" },
    ],
    []
  );

  const [configureTableOpened, setConfigureTableOpened] = React.useState(false);

  const openConfigureTable = React.useCallback(() => {
    setConfigureTableOpened(true);
  }, []);

  const closeConfigureTable = React.useCallback(() => {
    setConfigureTableOpened(false);
  }, []);

  const handleSubmitConfigureTable = React.useCallback(
    (params: {
      formats: Array<DatasheetSettingsConfigureTableFormat>;
      selectedDropdownFormatId?: DatasheetSettingsConfigureTableFormat["id"];
      formatName: string;
    }) => {
      onChange(params);
      closeConfigureTable();
    },
    [onChange, closeConfigureTable]
  );

  const checkFormatNameExists = React.useCallback(
    (formatName: string) =>
      Promise.resolve(formats.some((format) => format.name.toLowerCase() === formatName.toLowerCase())),
    [formats]
  );

  return {
    configureTableOpened,
    closeConfigureTable,
    openConfigureTable,
    handleSubmitConfigureTable,
    tableFormats,
    checkFormatNameExists,
    formats,
  };
};
